import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatAdjustmentResponse } from "../../utils/adjustment-utils";
import { buildParams } from "../../utils/admin-utils";

export function useAdjustments() {
	const [adjustments, setAdjustments] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchAdjustments(pagination = {}) {
		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const params = buildParams(pagination);

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				}
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/reajustes?${params.toString()}`,
				requestOptions
				
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao buscar reajustes.");
			}

			const data = await response.json();
			const adjustmentData = data.resultado || [];

			const responsePagination = {
				totalElements: data.totalElementos ?? 0,
				totalPages: data.totalPaginas ?? 0,
				page: data.pagina ?? 0,
				size: data.tamanho ?? pagination.size ?? 10
			};

			const formattedAdjustments = Array.isArray(adjustmentData)
				? adjustmentData.map(formatAdjustmentResponse)
				: [];

			setAdjustments(formattedAdjustments);

			return {
				ok: true,
				empty: formattedAdjustments.length === 0,
				adjustments: formattedAdjustments,
				pagination: responsePagination
			};
		} catch (requestError) {
			setAdjustments([]);
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		adjustments,
		loading,
		error,
		refetch: fetchAdjustments
	};
}